import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Modal from 'react-modal';
import axios from 'axios';

export default function CreateGroup({ viewModal, closeModal }) {
  const token = localStorage.getItem('token');

  const validationSchema = Yup.object().shape({
    group_name: Yup.string().required('Name is required'),
    description: Yup.string(),
  });
  const createGroup = async (values, actions) => {
    actions.setSubmitting(true);
    try {
      await axios.post(
        'https://secret-ridge-31139.herokuapp.com/api/group/create',
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      actions.setSubmitting(false);
      closeModal();
      window.location.reload();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Modal style={customStyles} isOpen={viewModal}>
      <div className={'p-5'}>
        <div className={'mb-2 flex flex-row justify-between items-center'}>
          <h3 className={'font-bold text-xl'}>Create new group</h3>
          <button onClick={closeModal}>
            <i className={'fas fa-times text-xl'} />
          </button>
        </div>
        <div>
          <Formik
            initialValues={{ group_name: '', description: '' }}
            validationSchema={validationSchema}
            onSubmit={(values, formikHelpers) =>
              createGroup(values, formikHelpers)
            }
          >
            {(props) => {
              return (
                <form>
                  <div>
                    <div className={'w-full my-2'}>
                      <label>Group name</label>
                      <input
                        name={'group_name'}
                        type={'text'}
                        className={
                          'mt-2 w-full p-3 border-2 rounded border-gray-300 bg-gray-100'
                        }
                        value={props.values.group_name}
                        onChange={props.handleChange('group_name')}
                      />
                    </div>
                    <div className={'w-full my-2'}>
                      <label>Group description</label>
                      <textarea
                        name={'description'}
                        row={4}
                        className={
                          'mt-2 w-full p-3 border-2 rounded border-gray-300 bg-gray-100'
                        }
                        value={props.values.description}
                        onChange={props.handleChange('description')}
                      />
                    </div>
                  </div>
                  <div className={'w-full mt-3'}>
                    <button
                      type={'button'}
                      onClick={() => props.handleSubmit()}
                      className={
                        'bg-yellow-500 text-white border-2  border-yellow-500  rounded px-5 py-3 w-full mb-2 lg:mb-0'
                      }
                    >
                      Create
                    </button>
                  </div>
                </form>
              );
            }}
          </Formik>
        </div>
      </div>
    </Modal>
  );
}
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: 350,
  },
};
